// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/shared/timezoneOptions.js

export const TIMEZONE_OPTIONS = [
  ["UTC", "UTC"],
  ["America/New_York", "Eastern Time — America/New_York"],
  ["America/Chicago", "Central Time — America/Chicago"],
  ["America/Denver", "Mountain Time — America/Denver"],
  ["America/Phoenix", "Arizona Time — America/Phoenix"],
  ["America/Los_Angeles", "Pacific Time — America/Los_Angeles"],
  ["America/Anchorage", "Alaska Time — America/Anchorage"],
  ["Pacific/Honolulu", "Hawaii Time — Pacific/Honolulu"],
  ["America/Toronto", "Toronto — America/Toronto"],
  ["America/Vancouver", "Vancouver — America/Vancouver"],
  ["Europe/London", "London — Europe/London"],
  ["Europe/Dublin", "Dublin — Europe/Dublin"],
  ["Europe/Paris", "Paris — Europe/Paris"],
  ["Europe/Berlin", "Berlin — Europe/Berlin"],
  ["Asia/Dubai", "Dubai — Asia/Dubai"],
  ["Asia/Kolkata", "India — Asia/Kolkata"],
  ["Asia/Singapore", "Singapore — Asia/Singapore"],
  ["Asia/Tokyo", "Tokyo — Asia/Tokyo"],
  ["Australia/Sydney", "Sydney — Australia/Sydney"],
];

export function isKnownTimezone(value) {
  return TIMEZONE_OPTIONS.some(([timezone]) => timezone === value);
}
